import { render, staticRenderFns } from "./NotAvailable.vue?vue&type=template&id=56013c23&scoped=true"
import script from "./NotAvailable.vue?vue&type=script&lang=js"
export * from "./NotAvailable.vue?vue&type=script&lang=js"
import style0 from "./NotAvailable.vue?vue&type=style&index=0&id=56013c23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56013c23",
  null
  
)

export default component.exports